import React from 'react'
import { Button, Row, Col, ButtonGroup, DropdownButton, MenuItem } from 'react-bootstrap'
import DocumentTitle from 'react-document-title'
import Backdrop from '_/shared/components/backdrop'
import ReactMixin from 'react-mixin'
import ImmutableRenderMixin from 'react-immutable-render-mixin'
import Input from '_/shared/components/input'
import createLinkToImmutable from '_/utils/createLinkToImmutable'
import getGravatarUrl from '_/utils/getGravatarUrl'

/**
 * My account page
 */
@ReactMixin.decorate(ImmutableRenderMixin)
class MyAccount extends React.Component {
  static propTypes = {
    account: React.PropTypes.object,
    groups: React.PropTypes.object,
    metros: React.PropTypes.object
  }

  static contextTypes = {
    router: React.PropTypes.func,
    store: React.PropTypes.object
  }

  static fetchData (store, params) {
    return {
      groups: store.get('/groups'),
      metros: store.get('/metros', { limit: 0 })
    }
  }

  constructor (props, context) {
    super(props, context)
    this.state = {
      account: props.account,
      link: createLinkToImmutable(this, 'account')
    }
  }

  changeGroup (group) {
    const account = this.state.account
      .setIn(['group', 'id'], group.get('id'))
      .setIn(['group', 'name'], group.get('name'))

    this.setState({ account })
  }

  async updateAccount (evt) {
    evt.preventDefault()
    const { store, router } = this.context
    const { account } = this.state

    try {
      await store.post('/account', account)
      router.transitionTo('dashboard')
    } catch (er) {
      this.setState({
        errors: er.response.body.details
      })
    }
  }

  render() {
    const { groups, metros } = this.props
    const { account, link } = this.state

    const backdropPhoto = getGravatarUrl(account.get('email'), 800)
    const photo = getGravatarUrl(account.get('email'), 600)

    return (
      <DocumentTitle title="My account">
        <Backdrop url={backdropPhoto}>
          <h3>My account</h3>
          <form onSubmit={::this.updateAccount}>
            <Row>
              <Col xs={6}>
                <Input
                  autoFocus
                  type="text"
                  valueLink={link('name')}
                  name="name"
                  errors={this.state.errors}
                  label="Name" />
                <Input
                  type="text"
                  valueLink={link('email')}
                  name="email"
                  errors={this.state.errors}
                  label="Email" />
                <Input
                  type="text"
                  valueLink={link('username')}
                  name="username"
                  errors={this.state.errors}
                  label="Handle" />

                {account.get('isAdmin') &&
                  <Input
                    type="select"
                    valueLink={link(['group','metro','id'])}
                    options={
                      metros.get('data').map(metro => ({
                        label: metro.get('name'),
                        value: metro.get('id')
                      }))
                      .toJS()
                    }
                    label="Metro" />
                }

                <h3>Preferences</h3>
                <Input
                  type="switch"
                  name="noProjEmail"
                  checkedLink={link('prefs.noProjEmail')}
                  errors={this.state.errors}
                  label="Skip project-related emails" />

                <h3>Group</h3>
                Active group: <b>{account.getIn(['group','name'])}</b> &nbsp;
                <ButtonGroup>
                  <Button href="/signup" bsSize="xsmall">Create new</Button>
                  <DropdownButton bsSize="xsmall" bsStyle="success" title="Switch to" dropup>
                    {groups.get('data').map((group, key) =>
                      <MenuItem
                        key={key}
                        onSelect={this.changeGroup.bind(this, group)}>
                        {group.get('name')}
                      </MenuItem>
                    )}
                  </DropdownButton>
                </ButtonGroup>
                <br/><br/>
                <p>
                  <Button
                    type="submit"
                    bsStyle="primary">
                    Save changes
                  </Button>
                </p>
              </Col>
              <Col xs={6}>
                <p className="text-center text-muted">
                  <img className="img-circle" src={photo} style={{ width: 300 }}/>
                  <br/><br/>
                  Profile pictures are generated using your email address from gravatar.com.  Update your picture <a href="http://en.gravatar.com/emails/">here</a>.
                </p>
              </Col>
            </Row>
          </form>
        </Backdrop>
      </DocumentTitle>
    )
  }
}

export default MyAccount



// WEBPACK FOOTER //
// ./modules/shared/pages/account/myAccount.js